/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `Skills` for the Caintra Connect frontend.
 * @module components/CompanyProfileSections/ThirdTab/Skills
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React from "react";
import "../index.css";
import { useTranslation } from "react-i18next";
import { getCompanyFieldValue } from "../../../utils/common";

const Skills = ({ company, selectedProfile = 0 }) => {
  const { t } = useTranslation();

  const skillsAndSpecializations = getCompanyFieldValue(
    company,
    "procesosYEspecialidades",
    selectedProfile,
    "",
  );
  const machineryAndEquipment = getCompanyFieldValue(
    company,
    "maquinariaYEquipo",
    selectedProfile,
    "",
  );
  const clients = getCompanyFieldValue(
    company,
    "clientes",
    selectedProfile,
    "",
  );

  return (
    <div className="profileSection">
      <h2 className="sectionTitle">
        {t("pages.companyProfile.skillsAndSpecialization")}
      </h2>
      <div className="gridContainer">
        <div className="gridRow">
          <div className="gridItem">
            <span className="gridLabel">
              {t("pages.companyProfile.processesAndSpecialties")}
            </span>
            <span className="gridValue">{skillsAndSpecializations}</span>
          </div>
          <div className="gridItem">
            <span className="gridLabel">
              {t("pages.companyProfile.productsAndAdditionalServices")}
            </span>
            <span className="gridValue">{machineryAndEquipment}</span>
          </div>
        </div>
        <div className="gridRow">
          <div className="gridItem">
            <span className="gridLabel">
              {t("pages.companyProfile.clients")}
            </span>
            <span className="gridValue">{clients}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
